import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

interface ITokenInterface {
  mykiot_access_token: string;
  mykiot_platform: string;
  mykiot_merchant_id: string;
  mykiot_branch_id: string;
}

const initialState: ITokenInterface = {
  mykiot_access_token: '',
  mykiot_platform: '',
  mykiot_merchant_id: '',
  mykiot_branch_id: '',
};

export const branchSlice = createSlice({
  name: "token",
  initialState,
  reducers: {
    setAccessToken: (state, action: PayloadAction<string>) => {
      state.mykiot_access_token = action.payload;
    },
    setPlatform: (state, action: PayloadAction<string>) => {
      state.mykiot_platform = action.payload;
    },
    setMerchantId: (state, action: PayloadAction<string>) => {
      state.mykiot_merchant_id = action.payload;
    },
    setBranchId: (state, action: PayloadAction<string>) => {
      state.mykiot_branch_id = action.payload;
    },
  },
});

export const { setAccessToken, setPlatform, setBranchId, setMerchantId } = branchSlice.actions;


export default branchSlice.reducer;
